// extracted by mini-css-extract-plugin
export default {"authPage":"AuthPage_authPage__vota0","inputField":"AuthPage_inputField__xPsTm"};